export const getOsType = () => {
  if (typeof navigator === 'undefined') return null;

  const { userAgent } = navigator;

  return /windows/i.test(userAgent)
    ? 'windows'
    : /android/i.test(userAgent)
      ? 'android'
      : /iPad|iPhone|iPod|ios/.test(userAgent)
        ? 'ios'
        : /Mac/.test(userAgent)
          ? 'mac'
          : null;
};

export const getInAppBrowserType = () => {
  if (typeof navigator === 'undefined') return null;

  const { userAgent } = navigator;

  return /FBAN|FBAV|FB_IAB/i.test(userAgent)
    ? 'facebook'
    : /Instagram/i.test(userAgent)
      ? 'instagram'
      : /Line/i.test(userAgent)
        ? 'line'
        : /KAKAOTALK/i.test(userAgent)
          ? 'kakaotalk'
          : /TwitterAndroid|Twitter for iPhone/i.test(userAgent)
            ? 'twitter'
            : /wv/i.test(userAgent) &&
                //welfarehello 앱 일 경우 null 반환
                !/welfarehello/i.test(userAgent) &&
                /Version\/[\d.]+.*Chrome/i.test(userAgent)
              ? 'webview'
              : null;
};

export const isInAppBrowser = () => {
  return getInAppBrowserType() !== null;
};
